export default "__VITE_ASSET__uB1nclvr__"